import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid, } from 'uuid';
import AsyncActionButton from '../button/AsyncActionButton';
import './SearchBar.css';

class SingleInputSearch extends React.Component {
  constructor(props) {
    super(props);
    this.button = React.createRef();
    this.comboId = uuid();
    this.inputId = uuid();
    const { comboFields = [], defaultText = '', } = props;
    const value = comboFields.length > 0 ? comboFields[0].value : '';
    this.state = {
      isLoading: false,
      comboBoxElement: this.buildComboBox(props),
      combo: {
        value,
      },
      search: {
        value: defaultText,
      },
    };
  }

  onLoadCompletion() {
    this.setState({
      isLoading: false,
    });
  }

  onReset() {
    const { comboFields = [], defaultText = '', } = this.props;
    const value = comboFields.length > 0 ? comboFields[0].value : '';
    const { combo, search, } = this.state;
    this.setState({
      combo: {
        ...combo,
        value,
      },
      search: {
        ...search,
        value: defaultText,
      },
    });
  }

  onComboChange(event, props) {
    const { onComboChange, } = props;
    if (onComboChange) {
      onComboChange({ ...event, });
    }

    this.setState({
      combo: {
        value: event.currentTarget.value,
      },
    });
  }

  onInputTextChange(event, props) {
    const { onTextChange, } = props;
    if (onTextChange) {
      onTextChange({ ...event, });
    }

    this.setState({
      search: {
        value: event.currentTarget.value.trim(),
      },
    });
  }

  onKeyPress = (event, props) => {
    if (event.key === 'Enter') {
      this.onClick(event, props);
    }
  };

  onClick(event, props) {
    const { onClick, } = props;
    const { combo, search, } = this.state;
    if (onClick) {
      this.beginLoading();
      onClick({
        event: {
          ...event,
        },
        combo: {
          ...combo,
        },
        search: {
          ...search,
        },
        kill: () => this.onLoadCompletion(),
        reset: () => this.onReset(),
      });
    }
  }

  beginLoading() {
    this.setState({
      isLoading: true,
    });
  }

  buildComboBox(props) {
    const { comboFields = [], } = props;
    if (comboFields.length === 0) {
      return null;
    }
    return (
      <select
        id={this.comboId}
        onBlur={event => this.onComboChange(event, props)}
          className="form-select mt-2 me-2"
      >
        {comboFields.map(data => (
          <option key={uuid()} value={data.value}>
            {data.display}
          </option>
        ))}
      </select>
    );
  }

  clickConsumer(clickAction) {
    const { clickConsumer, } = this.props;
    if (clickConsumer) {
      clickConsumer(clickAction);
    }
  }

  render() {
    const { isLoading, comboBoxElement, } = this.state;
    const { hidden, defaultText = '', serviceOfferingDropdown, } = this.props;

    return (
      <div hidden={hidden} className="search-bar-container">
        <div className="search-bar-form">
          {comboBoxElement}
          <input
            id={this.inputId}
            defaultValue={defaultText}
            className="form-control mt-2 me-2 search-bar-input"
            type="search"
            placeholder="Search"
            aria-label="Search"
            onChange={event => this.onInputTextChange(event, this.props)}
            onKeyDown={event => this.onKeyPress(event, this.props)}
          />
          {serviceOfferingDropdown}
          <AsyncActionButton
            isLoading={isLoading}
            loadingVariant="secondary"
            variant="success"
            contents="Search"
            className="mt-2 search-bar-button"
            clickConsumer={func => this.clickConsumer(func)}
            onClick={event => this.onClick(event, this.props)}
          />
        </div>
      </div>
    );
  }
}

SingleInputSearch.defaultProps = {
  comboFields: [],
  hidden: false,
  defaultText: '',
  clickConsumer: null,
  serviceOfferingDropdown: null,
};

SingleInputSearch.propTypes = {
  comboFields: PropTypes.array,
  hidden: PropTypes.bool,
  defaultText: PropTypes.string,
  clickConsumer: PropTypes.func,
  serviceOfferingDropdown: PropTypes.node,
};

export default SingleInputSearch;
